/** @format */

import React, { useEffect } from "react";
import { Box } from "@mui/material";

/**
 * Google AdSense Banner Ad Component
 * Displays a responsive banner ad
 * 
 * IMPORTANT: Replace "ca-pub-XXXXXXXXXX" with your actual Google AdSense Publisher ID
 * You can find this in your Google AdSense account under Account > Account information
 * 
 * @param {string} adSlot - The ad slot ID from Google AdSense
 * @param {string} style - Additional inline styles
 * @param {string} className - Additional CSS classes
 */
const GoogleAdBanner = ({
  adSlot = "1234567890",
  style = {},
  className = "",
}) => {
  // Get ad client ID from environment variable or use default
  const adClient = process.env.REACT_APP_GOOGLE_ADS_CLIENT_ID || "ca-pub-XXXXXXXXXX";

  useEffect(() => {
    try {
      // Push ad to Google AdSense
      if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error("Error loading Google Ad Banner:", err);
    }
  }, []);

  return (
    <Box
      className={`google-ad-banner ${className}`}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        margin: "20px 0",
        minHeight: "90px",
        ...style,
      }}
    >
      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          maxWidth: "728px",
          height: "90px",
        }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </Box>
  );
};

export default GoogleAdBanner;

